<section
  class="bg-white py-12 md:py-16 relative overflow-hidden border-t border-b border-gray-200"
>
  <!-- Decorative background elements -->
  <div
    class="absolute top-0 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl"
  ></div>
  <div
    class="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"
  ></div>

  <div
    class="flex flex-col items-center justify-center md:flex-row md:gap-6 relative z-10 px-4"
  >
    <div class="text-center mb-6 md:mb-0 animate-fadeInUp">
      <h1 class="text-primary text-2xl md:text-4xl font-bold mb-2">
        Filtros <span class="text-secondary">certificados</span> por
      </h1>
      <p class="text-gray-700 text-sm md:text-base">
        Máxima calidad y seguridad garantizada
      </p>
    </div>
    <div
      class="animate-fadeInUp hover:scale-110 transition-transform duration-300 bg-primary rounded-2xl p-4 shadow-medium"
      style="animation-delay: 0.2s"
    >
      <img
        src="assets/anmat-nuevo.png"
        alt="ANMAT Certificación"
        class="h-12 md:h-16 w-auto object-contain"
      />
    </div>
  </div>

  <div class="mt-8 text-center relative z-10 px-4">
    <div
      class="inline-flex items-center bg-secondary/10 border border-secondary/30 rounded-full px-4 md:px-6 py-3 text-primary"
    >
      <svg
        class="w-5 h-5 mr-2 text-secondary flex-shrink-0"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="font-semibold text-sm md:text-base"
        >Cumplimos con todas las normativas de seguridad</span
      >
    </div>
  </div>
</section>
<!--<div class="w-full text-primary bg-cover bg-center" style="background-image: url('assets/vostoma.jpg');" >
  <div class="px-5 md:px-20 py-32">
    <h1 class="text-2xl font-medium">Vos tomá agua, nosotros</h1>
    <h1 class="text-2xl"><span class="font-bold">nos encargamos del resto</span></h1>
  </div>
</div>-->
